import { AnyObject } from 'final-form';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import OwnershipContactCategory from 'src/models/OwnershipContactCategory';
import LeaseGenerationOwnerData from 'src/models/leasing/LeaseGenerationOwnerData';
import Ownership from 'src/models/tract_detail/Ownership';

interface IContactCategoryFormProps {
    selectedOwnershipIds: Array<number>;
    ownerDetail: LeaseGenerationOwnerData;
    ownership: Ownership;
    contactCategories: Array<OwnershipContactCategory>;
    saveComplete: boolean;

    onSubmit: (data: { contactCategory: number }, event: React.FormEvent<HTMLFormElement>) => void;
}

const ContactCategoryForm = (props: IContactCategoryFormProps) => {
    const removeCat: OwnershipContactCategory = {
        id: 0,
        isCrossProject: false,
        isCrossProjectChecked: false,
        name: '(Remove Contact Category)',
    };

    const { register, handleSubmit } = useForm();
    const [contactCategorySelected, setContactCategorySelected] = useState<boolean>(false);
    const [contactCategoryList, setContactCategoryList] = useState<Array<OwnershipContactCategory>>([]);

    useEffect(() => {
        if (props.contactCategories?.length > 0) {
            let categoryList = [removeCat];
            categoryList = categoryList.concat(props.contactCategories);
            setContactCategoryList(categoryList);
        }
    }, [props.contactCategories]);

    const showSelectedGlobalIds = () => {
        if (props.selectedOwnershipIds.length > 0) {
            return props.selectedOwnershipIds.map((selectedOwnershipId: number, index) => {
                const tempTract = props.ownerDetail?.tracts.find((x) => x.ownershipId === selectedOwnershipId);
                if (tempTract) {
                    const tempGlobalId = `${tempTract.sectionNumber}.${tempTract.tractNumber}-${tempTract.horizonNumber}`;
                    return (
                        <>
                            <span key={index}>{tempGlobalId}</span>
                            {index < props.selectedOwnershipIds.length - 1 ? <span>, </span> : null}
                        </>
                    );
                } else {
                    return <span />;
                }
            });
        } else {
            return <span />;
        }
    };

    const onContactCategorySelected = (event: AnyObject) => {
        setContactCategorySelected(event.target.value !== '-- Select --');
    };

    return (
        <div style={{ width: '50%', borderRight: '1px solid grey', margin: '.5rem', paddingRight: '1rem' }}>
            <>
                <form onSubmit={handleSubmit(props.onSubmit)}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div>Note</div>
                        <div>
                            <span style={{ marginRight: '1rem' }}>Attached Tracts:</span>
                            {showSelectedGlobalIds()}
                        </div>
                    </div>
                    <RHFSelect
                        name="contactCategory"
                        label="Contact Category"
                        options={contactCategoryList.map((cc => {
                            return { value: cc.id, label: cc.name };
                        }))}
                        register={register}
                        style={{ width: '100%' }}
                        onChange={(e) => onContactCategorySelected(e)}
                    />
                    <br />
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <input
                            type="submit"
                            value={props.saveComplete ? 'Save Complete!' : 'Save'}
                            style={
                                props.selectedOwnershipIds?.length > 0 && contactCategorySelected
                                    ? { border: '0', backgroundColor: '#6393C1', color: 'white', height: '3rem' }
                                    : { border: '0', backgroundColor: '#bbbbbb', color: 'darkgrey', height: '3rem' }
                            }
                            disabled={!(props.selectedOwnershipIds?.length > 0 && contactCategorySelected)}
                        />
                        {props.selectedOwnershipIds?.length === 0 && <div>No Tracts selected</div>}
                    </div>
                </form>
            </>
        </div>
    );
};

export default ContactCategoryForm;


// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/ContactCategoryForm.tsx